<div class="search-container-mobile">
    <!-- Search Mode Toggle -->
    <div *ngIf="(providerSearchResults$ | async) === null && (locationSearchResults$ | async) === null" class="search-toggle-container-mobile">
        <button 
            mat-button 
            [class.search-toggle-btn-selected]="(searchMode$ | async) === 'provider'"
            [class.search-toggle-btn-unselected]="(searchMode$ | async) !== 'provider'"
            (click)="toggleSearchMode('provider')">
            {{providerBtnText}}
        </button>
        <button 
            mat-button 
            [class.search-toggle-btn-selected]="(searchMode$ | async) === 'location'"
            [class.search-toggle-btn-unselected]="(searchMode$ | async) !== 'location'"
            (click)="toggleSearchMode('location')">
            {{locationBtnText}}
        </button>
    </div>

    <!-- Search Content Area -->
    <div class="search-content-mobile">
        <!-- Provider Search Mode -->
        <div *ngIf="(searchMode$ | async) === 'provider'">
            <!-- Show search input if no results -->
            <app-provider-search-mobile
                *ngIf="(providerSearchResults$ | async) === null"  
                [locale]="locale"
                [isPlus]="isPlus || false"
                [currentLocation]="currentLocation"
                [providerTypeAheadOptions]="providerSearchTypeAheadOptions"
                [cityZipTypeAheadOptions]="cityZipTypeAheadOptions"
                [providerQuickSearchOptions]="providerQuickSearchOptions"
                [providerSearchFilters]="providerSearchFilters"
                [patientAffiliation]="patientAffiliation">
            </app-provider-search-mobile>
            
            <!-- Show results if search has been performed -->
            <div *ngIf="(providerSearchResults$ | async) !== null">
                <!-- Show filter panel overlay if toggle is true -->
                <app-provider-search-filter-mobile
                    *ngIf="(showSpinner$ | async) === false && (providerSearchFilterToggle$ | async) === true && (providerSearchFilters$ | async) !== null"
                    [isPlus]="isPlus || false"
                    [providerTypeAheadOptions]="providerSearchTypeAheadOptions">
                </app-provider-search-filter-mobile>                <!-- Show results -->
                <app-provider-search-results-mobile
                    *ngIf="(currentProviderDetail$ | async) === null"
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation"
                    [cityZipTypeAheadOptions]="cityZipTypeAheadOptions">
                </app-provider-search-results-mobile>
                <app-provider-search-details-mobile
                    *ngIf="(currentProviderDetail$ | async) !== null && (currentProviderDetailsLocation$ | async) === null"
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation">
                </app-provider-search-details-mobile>
                <app-location-search-details-mobile
                    *ngIf="(currentProviderDetail$ | async) !== null && (currentProviderDetailsLocation$ | async) !== null"
                    [providerDetails]="currentProviderDetails"
                    [providerDetailsLocation]="currentProviderDetailsLocation">
                </app-location-search-details-mobile>
            </div>
        </div>

        <!-- Location Search Mode -->
        <div *ngIf="(searchMode$ | async) === 'location'">
            <!-- Show search input if no results -->
            <app-location-search-mobile
                *ngIf="(locationSearchResults$ | async) === null"  
                [locale]="locale"
                [isPlus]="isPlus || false"
                [currentLocation]="currentLocation"
                [locationTypeAheadOptions]="locationSearchTypeAheadOptions"
                [cityZipTypeAheadOptions]="cityZipTypeAheadOptions"
                [locationQuickSearchOptions]="locationQuickSearchOptions"
                [locationSearchFilters]="locationSearchFilters">
            </app-location-search-mobile>
            
            <!-- Show results if search has been performed and no location detail is selected -->
            <div *ngIf="(locationSearchQuery$ | async) !== null && (currentLocationDetail$ | async) === null">
                <!-- Show filter panel overlay if toggle is true -->
                <app-location-search-filter-mobile
                    *ngIf="(showSpinner$ | async) === false && (locationSearchFilterToggle$ | async) === true  && (locationSearchFilters$ | async) !== null"
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation">
                </app-location-search-filter-mobile>
                
                <!-- Show results -->
                <app-location-search-results-mobile
                    [isPlus]="isPlus || false"
                    [currentLocation]="currentLocation"
                    [cityZipTypeAheadOptions]="cityZipTypeAheadOptions">
                </app-location-search-results-mobile>
            </div>

            <!-- Show location details when a location is selected -->
            <app-location-search-details-mobile
                *ngIf="(currentLocationDetail$ | async) !== null && (currentLocationDetailsProvider$ | async) === null"
                [isPlus]="isPlus || false">
            </app-location-search-details-mobile>
            <app-provider-search-details-mobile
                    *ngIf="(currentLocationDetail$ | async) !== null && (currentLocationDetailsProvider$ | async) !== null"
                    [locationDetails]="currentLocationDetails"
                    [locationDetailsProvider]="currentLocationDetailsProvider">
            </app-provider-search-details-mobile>
        </div>
    </div>
</div>
